/** Product branding — override via VITE_APP_NAME in .env */
export const BRAND = {
  name: 'Fattah',
  tagline: 'Multi-tenant business platform — POS, CRM, finance, HR, and more.',
  logoPath: '/fattah-auth-logo.png',
  authBackgroundPath: '/auth-bg.jpg',
} as const;

const TITLE_SEP = ' · ';

/** Browser tab / card title: company name + project (module) name. */
export function fattahProjectTitle(projectName: string): string {
  const project = projectName.trim();
  if (!project) return BRAND.name;
  return `${BRAND.name}${TITLE_SEP}${project}`;
}

/** Workspace header: company on top, project below. */
export function fattahBrandLines(projectName?: string | null): { company: string; project: string | null } {
  const project = projectName?.trim() || null;
  return { company: BRAND.name, project };
}
